// SelectField — labeled <select> styled to match FormField. Use this for
// foreign-key picks or enum dropdowns inside forms (e.g. Chamber form's
// Access Point and Level pickers). For pill-style enum pickers, prefer
// ChipSelector; for nav-style "Label: Value ▾" toggles, prefer Dropdown.

import React from 'react'
import clsx from 'clsx'

interface SelectOption {
  label: string
  value: string
}

interface SelectFieldProps {
  label: string
  value: string
  onChange: (value: string) => void
  options: readonly SelectOption[]
  error?: string | null
  /** Set false to render the control disabled (greyed out, no interaction). */
  editable?: boolean
}

export const SelectField: React.FC<SelectFieldProps> = ({
  label,
  value,
  onChange,
  options,
  error,
  editable = true,
}) => (
  <div className="flex flex-1 flex-col gap-xs">
    <label className="text-sm text-textSecondary">{label}</label>
    <select
      value={value}
      onChange={e => onChange(e.target.value)}
      disabled={!editable}
      className={clsx(
        'h-10 rounded-md border bg-surface px-md text-md text-textPrimary outline-none transition-colors',
        error
          ? 'border-statusRed'
          : 'border-surfaceBorder focus:border-primary',
        !editable && 'opacity-60',
      )}
    >
      {options.map(opt => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
    {error && <span className="text-xs text-statusRed">{error}</span>}
  </div>
)
